<template>
  <div>
    <pdf ref="pdf" class="pdf" :src="src" :page="page" @num-pages="(p) => (maxPage = p)" @loaded="isLoading = false" />
    <div class="pdf-button-container">
      <b-button :disabled="page == 1" @click="prev">
        {{ $t("prev") }}
      </b-button>
      <b-button icon-left="download" @click="saveAs" />
      <b-button :disabled="page == maxPage" @click="next">
        {{ $t("next") }}
      </b-button>
    </div>
    <b-loading :active="isLoading || loading" :is-full-page="false" :can-cancel="false" />
  </div>
</template>

<script>
import pdf from "vue-pdf";
import { saveAs } from "file-saver";

export default {
  name: "PDFViewer",
  components: {
    pdf,
  },
  props: {
    src: {
      type: String,
      default: "",
    },
    blob: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      maxPage: 1,
      isLoading: false,
    };
  },
  watch: {
    src: {
      immediate: true,
      handler() {
        this.isLoading = true;
      },
    },
  },
  methods: {
    prev() {
      if (this.page > 1) {
        this.page--;
      }
    },
    next() {
      if (this.page < this.maxPage) {
        this.page++;
      }
    },
    saveAs() {
      if (this.blob) {
        saveAs(this.blob, "download.pdf");
      } else {
        saveAs(this.src, "download.pdf");
      }
    },
  },
};
</script>

<style scoped>
.pdf {
  width: 100%;
  border: 2px solid #202020;
}

.pdf-button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 1em;
}
</style>
>
